<template>
    <div class="row m-0">
      <div class="col-xs-12 col-md-12 col-sm-12 p-0 d-flex">
         <div class="col-xs-2 col-md-2 col-sm-2 p-0 profile-menu ">
                <profile-menu :roleId="roleId" @menuClicked="menuClicked" :activeTab="activeTab" :isDashboardCustomizable="isDashboardCustomizable" :roleInfo="roleInfo"></profile-menu>
          </div>
           <div class="col-xs-10 col-md-10 col-sm-10 p-0">
                    <common-header
                    v-if="profileMenuClicked!=='logout'"
                    @closepopup="closepopup"
                    @emit-close-event="closePage"
                    @changePage="getPageName"
                    :roleId="roleId"
                    :displaySubheader="displaySubheader"
                    :header="header"
                    :subheader="subheader"
                    :breadcrumb="breadcrumb"
                    :isDashboardCustomizable="isDashboardCustomizable"
                    :roleInfo="roleInfo"
                  ></common-header>
                <div>

                  <template v-if="profileMenuClicked=='profile'">
                    <profile-popup
                      ref="profilePopUp"
                      @closedConfirmPopup="redirectProfile"
                      @closepopup="closepopup"
                      @emitBreadCrumb="updateBreadCrumb"
                      @logoutUser="logoutUser"
                      :closeSubPage="closeSubPage"
                      :roleInfo="roleInfo"
                    ></profile-popup>
                  </template>
                  <template v-if="profileMenuClicked=='team'">
                    <team
                      @closepopup="closepopup"
                      @emitBreadCrumb="updateBreadCrumb"
                      :roleId="roleId"
                      :closeSubPage="closeSubPage"
                      :downgradeCount="downgradeCount"
                      :roleInfo="roleInfo"
                    ></team>
                  </template>
                  <template v-if="profileMenuClicked=='companyProfile'">
                    <company-profile ref="companyProfile" @closedConfirmPopup="redirectProfile" @closepopup="closepopup" :roleId="roleId"  @emitBreadCrumb="updateBreadCrumb" :roleInfo="roleInfo"></company-profile>
                  </template>
                  <template v-if="profileMenuClicked=='billing'">
                    <billing  @closepopup="closepopup" :closeSubPage="closeSubPage" @emitBreadCrumb="updateBreadCrumb" :roleId="roleId"></billing>
                  </template>
                  <template v-if="profileMenuClicked=='changePassword'">
                    <change-password  @closepopup="closepopup" :roleId="roleId"></change-password>
                  </template>
                  <template v-if="profileMenuClicked=='services'">
                    <services  @closepopup="closepopup" :roleId="roleId" :closeSubPage="closeSubPage" @emitBreadCrumb="updateBreadCrumb " :roleInfo="roleInfo"></services>
                  </template>
                  <template v-if="profileMenuClicked=='tour'">
                    <virtual-tour  @closepopup="closepopup" :roleId="roleId"></virtual-tour>
                  </template>
                  </div>
           </div>
      </div>

          <loader :loadingStatus="loaderStatus"></loader>
    </div>
  </template>

<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import VirtualTour from '../VirtualTour/VirtualTour.vue';
import ProfileMenu from './AccountSettingsLeftMenu.vue';
import ProfilePopup from './UserProfile.vue';
import Team from './Team/Team.vue';
import CompanyProfile from './CompanyProfileNew.vue';
import CommonHeader from './AccountSettingsHeader.vue';
import Billing from './Billing.vue';
import Services from './Services.vue';
import ChangePassword from './ChangePasswordNew.vue';
import { isDashboardCustomizable } from '../../apis/dashboardCustomization';

export default {
  props: {
    regWatchprefTab: String,
    userAction: String,
    roleId: Number,
    account_id: Number,
    roleInfo: Object
  },
  components: {
    Loader,
    ProfileMenu,
    ProfilePopup,
    Team,
    CompanyProfile,
    CommonHeader,
    Billing,
    Services,
    ChangePassword,
    VirtualTour,
  },
  data() {
    return {
      downgradeCount: 0,
      holdRoute: '',
      profileMenuClicked: '',
      header: '',
      subheader: '',
      breadcrumb: '',
      activeTab: '',
      closeSubPage: '',
      displaySubheader: true,
      loaderStatus: false,
      dashboardCustomizable: null,
      isDashboardCustomizable: false,
    };
  },
  async mounted() {
    if (!this.$route.query.page) this.$router.push('/layout/account-settings?page=team');
    EventBus.$on('openTeams', (userSelectedValue) => {
      this.downgradeCount = userSelectedValue;
      this.holdRoute = 'team';
      this.redirectRoute('team');
    });
    this.$root.$on('selectedMenu', (data) => {
      this.menuClicked(data);
    });
    $('#basePopup').on('hidden.bs.modal', () => {
      $('.modal-backdrop').remove();
    });
    $('#basePopup').on('show.bs.modal', () => {
      this.checkDashboardCustomizable();
    });
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
    // const pageName = this.$route.query.page;
    this.menuClicked(this.$route.query.page);
  },
  watch: {
    userAction() {
      if (this.userAction) {
        this.menuClicked(this.userAction);
      }
    },

    async $route() {
      // const pageName = this.$route.query.page;
      if (this.$route.query.page) this.menuClicked(this.$route.query.page);
      else {
        this.$route.query.page = 'profile';
        this.menuClicked(this.$route.query.page);
      }
      // if (this.$route.params.initializePage) {
      //   await this.initialize();
      // }
    },

  },

  beforeDestroy() {
    EventBus.$off('openTeams');
  },
  methods: {
    redirectProfile(closeBasePopup) {
      if (closeBasePopup === 'closeBasePopup') {
        this.reset();
      } else {
        this.redirectRoute(this.holdRoute);
      }
    },
    validateConfirmPopUp() {
      if (
        this.activeTab === 'profile'
          && !this.$refs.profilePopUp.disableButtonForProfile
      ) {
        return false;
      }
      if (
        this.activeTab === 'companyProfile'
          && !this.$refs.companyProfile.disableButtonForCompanyProfile
      ) {
        return false;
      }
      return true;
    },
    reset() {
      this.holdRoute = '';
      this.activeTab = '';
      this.profileMenuClicked = false;
      this.$emit('popUpClosed');
      $('#basePopup').modal('hide');
    },
    closepopup(closeBasePopup) {
      if (this.validateConfirmPopUp()) {
        // this.reset();
      } else {
        const activeTabName = this.activeTab;
        if (activeTabName === 'profile') {
          this.$refs.profilePopUp.toggleConfirmPopUp(closeBasePopup);
        } else if (activeTabName === 'companyProfile') {
          this.$refs.companyProfile.toggleConfirmPopUp(closeBasePopup);
        }
      }
    },
    logoutUser() {
      this.$emit('logoutUser');
    },
    menuClicked(data) {
      this.downgradeCount = 0;
      this.holdRoute = data;
      if (this.validateConfirmPopUp()) {
        this.redirectRoute(data);
      } else {
        const activeTabName = this.activeTab;
        if (activeTabName === 'profile') {
          this.$refs.profilePopUp.toggleConfirmPopUp();
        } else if (activeTabName === 'companyProfile') {
          this.$refs.companyProfile.toggleConfirmPopUp();
        }
      }
    },
    redirectRoute(data) {
      this.activeTab = data;
      this.profileMenuClicked = data;
      // if (data === 'team') {
      //   this.$router.push('/layout/account-settings?page=team');
      //   EventBus.$emit('resetTeams');
      // }
      if (this.validateLogout(data)) {
        this.validateHeader(data);
        this.updateBreadCrumb(false);
      }
    },
    newHeaderNames(data) {
      const language = localStorage.getItem('language');
      if (data === 'profile') {
        if (language === 'Portuguese') {
          return 'Perfil de usuário';
        }
        return 'User Profile';
      }
      if (data === 'companyProfile') {
        if (language === 'Portuguese') {
          return 'Perfil da companhia';
        }
        return 'Company Profile';
      }
      if (data === 'changePassword') {
        if (language === 'Portuguese') {
          return 'Mudar senha';
        }
        return 'Change Password';
      }
      return data;
    },
    validateHeader(data) {
      this.header = this.newHeaderNames(data);
      this.subheader = data;
      const language = localStorage.getItem('language');
      if (data !== 'profile' && data !== 'tour' && data !== 'companyProfile' && data !== 'changePassword' && data !== 'team' && data !== 'services' && data !== 'billing') {
        this.header = 'Account Settings';
        this.displaySubheader = true;
      } else if (data === 'tour') {
        this.header = language === 'Portuguese' ? 'Excursão virtual' : 'Virtual Tour';
        this.displaySubheader = false;
      } else if (data === 'team') {
        this.header = language === 'Portuguese' ? 'Equipe' : 'Team';
        this.displaySubheader = false;
      } else if (data === 'billing') {
        this.header = language === 'Portuguese' ? 'Cobrança' : 'Billing';
        this.displaySubheader = false;
      } else if (data === 'services') {
        this.header = language === 'Portuguese' ? 'Serviços' : 'Services';
        this.displaySubheader = false;
      } else {
        this.displaySubheader = false;
      }
    },
    updateBreadCrumb(breadcrumb) {
      this.breadcrumb = breadcrumb;
      this.closeSubPage = '';
    },
    validateLogout(data) {
      if (data === 'logout') {
        this.loaderStatus = true;
        // this.$emit('logoutUser');
        socket.removeAllListeners(`alertSaveMultiRegistrationDetails_${localStorage.getItem('userId')}`);
        document.cookie = 'Authorization=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        document.cookie = 'redirect_url=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        localStorage.clear();
        sessionStorage.clear();
        this.$router.push('/login');
        return false;
      }
      return true;
    },
    closePage() {
      this.closeSubPage = 'close';
    },
    getPageName(pageName) {
      this.menuClicked(pageName);
    },
    async checkDashboardCustomizable() {
      this.isDashboardCustomizable = await isDashboardCustomizable(JSON.parse(localStorage.getItem('userData')).account_id, JSON.parse(localStorage.getItem('userData')).role_id);
      // if (this.isDashboardCustomizable) {
      //   EventBus.$emit('loadDashhboard');
      // }
    },
  },
};
</script>
  <style scoped>
  .profile-menu {
    /* width:200px; */
    border-right: 1px solid #D3D3D3;
  }
  #left {
    /* margin-top: 129px; */
    padding: 10px 0 0;
    background-color: #FFFFFF;
    /* border-top-left-radius: 10px; */
    /* border-bottom-left-radius: 10px; */
    /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25); */
    width: 200px;
    /* top: 0; */
    /* position: fixed; */
    /* height: inherit; */
    /* z-index: 1; */
    float:left;
    border-right: 1px solid #D3D3D3;
    border-bottom: 1px solid #B3B3B3;
  }
  .pop_wrapper {
    /* height: 85vh; */
    border: 1px solid #B3B3B3;
  }
  /* @media screen and (min-width: 1300px) AND (max-height: 430px) {
      .pop_wrapper {
          height: 91vh;
      }
  } */
  #right {
    padding: 0px;
    /* background-color: #ffff;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px; */
    margin-left: 200px;
  }
  .modal-body {
    padding: 0px;
  }
  /* @media (max-width: 1300px) {
    #left {
      display: none;
    }
    #right {
      border-radius: 10px;
      margin: 0px;
    }
  } */
  .modal-open .modal {
    overflow: hidden;
  }
  .custom-modal-class {
    margin-top: 4%;
    width: 80% !important;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    .pop_wrapper {
      height: 85vh;
    }
    .modal-dialog {
      vertical-align: top;
      margin-top: 10%;
    }
  }
  @media screen and (max-width: 767px) {
    .custom-modal-class {
      margin-top: 3%;
      width: 80% !important;
    }
    .pop_wrapper {
      height: 90vh;
    }
  }
  /* iphoneX landscape  */
  @media (device-width: 812px) and (device-height: 375px){
    .pop_wrapper {
      height: 90vh!important;
    }
    .modal-dialog {
      margin-top: 2%!important;
      width: 95% !important;
    }
  }
  </style>
